import PencilIcon from '@/fsd/shared/ui/icons/pencil';
import TruncatedTextWithTooltip from '@/fsd/shared/ui/TruncatedTextWithTooltip/TruncatedTextWithTooltip';
import cx from 'classnames';
import { useRef, useState } from 'react';
import { useFilterPanelContext } from '../../../../context/FilterPanelContext';
import style from '../../../../FilterPanel.module.scss';
import { SavePresetModal } from '../../../../SavePresetModal';
import { Preset } from '../../../../types';

interface IProps {
  f: Preset;
}

const truncateFilterName = (name: string, maxLength: number = 20): string => {
  if (name.length <= maxLength) {
    return name;
  }
  return `${name.substring(0, maxLength)}...`;
};

const PresetButton = ({ f }: IProps) => {
  const {
    handleDeleteFilter,
    setValues,
    activePresetId,
    setActivePresetId,
    fields,
    autocomplete,
    setAutocomplete,
    onPresetChange,
    onSearch,
  } = useFilterPanelContext();

  const [presetName, setPresetName] = useState<string>(f.name);
  const [showSaveModal, setShowSaveModal] = useState<boolean>(false);

  const saveBtnRef = useRef<HTMLButtonElement>(null);

  const updatePresetClickHandler = () => {
    setShowSaveModal(true);
  };

  const handleApplyFilter = (preset: Preset) => {
    // @ts-ignore
    window.isPresetSelected = true;

    setValues(preset.filters);
    setActivePresetId(Number(preset.id));

    const newAutocomplete = { ...autocomplete };
    fields.forEach((field) => {
      if (
        field.type === 'select' &&
        typeof preset.filters[field.key] === 'string'
      ) {
        newAutocomplete[field.key] = String(preset.filters[field.key]);
      }
    });
    setAutocomplete(newAutocomplete);


    onSearch?.(preset.filters);
  };

  const handleSaveFilterPreset = async () => {
    onPresetChange({ id: f.id, name: presetName });
    setShowSaveModal(false);
  };

  return (
    <div key={f.id} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <button
        className={cx(
          style.savedFilterBtn,
          showSaveModal ? style.focusedFilterBtn : '',
          f.id === activePresetId ? style.savedFilterBtnActive : ''
        )}
        onClick={() => handleApplyFilter(f)}
        ref={saveBtnRef}
      >
        {/* {truncateFilterName(f.name)} */}
        <TruncatedTextWithTooltip text={f.name} maxLines={1} />
        <button
          className={style.editFilterBtn}
          title="Обновить пресет"
          onClick={(e) => {
            e.stopPropagation();
            updatePresetClickHandler();
          }}
        >
          <PencilIcon />
        </button>
      </button>
      {showSaveModal && (
        <div
          style={{
            position: 'absolute',
            zIndex: 100,
            left: saveBtnRef.current?.offsetLeft || 0,
            top: (saveBtnRef.current?.offsetTop || 0) + 48,
          }}
        >
          <SavePresetModal
            value={presetName}
            onChange={setPresetName}
            onSave={handleSaveFilterPreset}
            onDelete={() =>
              handleDeleteFilter && handleDeleteFilter(Number(f.id))
            }
            onCancel={() => setShowSaveModal(false)}
            isEdit={true}
          />
        </div>
      )}
    </div>
  );
};

export default PresetButton;
